export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";